import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.removeProduct,
    sections: [
        createInvalidPartSection('partNumber'),
    ],
};
